import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import claraviewBrand from "../../../assets/claraViewMedia/claraview-logo-transparent.png";
import landingPageLady from "../../../assets/claraViewMedia/landing-page-lady.jpg"
import "../../ClaraView/index.css";
import { generateRandomAlphaNumeric } from "../../../Utils/alphaNumeric";
import { getTpScanAppDetails } from "../../../Services/APIs/appDetails";
import { ArrowRight } from "lucide-react";
import { logEvent } from "../../../Utils/logEvent";

const LandingPage = () => {
    const { userName } = useParams();
    const client = `claraview-${userName}`;
    const navigate = useNavigate();
    const [uid, setUid] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const takeScan = () => {
        logEvent({ app: client, uid, event: "clicked on take scan" });
        navigate("/claraview/demo");
    };

    useEffect(() => {
        findCompany();
    }, []);

    const findCompany = async () => {
        try {
            const result = await getTpScanAppDetails({ c: client });
            const { email } = result.data.data;
            setLoading(false);
            setError("");
            goAhead(email);
        } catch (err) {
            setLoading(false);
            if (err.status === 404) {
                setError("Clinic not found or invalid url");
            } else {
                setError("Something went wrong");
            }
            logEvent({ app: client, event: "getTpScanAppDetails failed", error: err });
        }
    };

    const goAhead = (email) => {
        localStorage.clear();
        const hasReloaded = sessionStorage.getItem("hasReloaded");
        if (!hasReloaded) {
            sessionStorage.setItem("hasReloaded", "true");
            window.location.reload();
        }

        const randomString = generateRandomAlphaNumeric(2);
        const timestamp = Date.now().toString();
        const randomString2 = generateRandomAlphaNumeric(1);
        const unique = randomString + timestamp + randomString2;

        setUid(unique);
        localStorage.setItem("usertpi", JSON.stringify({ usertpi: unique }));
        localStorage.setItem("ce", email);
        localStorage.setItem("company", client);
        logEvent({ app: client, uid: unique, event: "visited landing page" });
    };

    const renderButtonContent = () => {
        if (loading) {
            return (
                <div className="flex w-full items-center justify-center gap-2">
                    <span className="h-3 w-3 rounded-full bg-[#333333] animate-bounce [animation-delay:-0.3s]"></span>
                    <span className="h-3 w-3 rounded-full bg-[#333333] animate-bounce [animation-delay:-0.15s]"></span>
                    <span className="h-3 w-3 rounded-full bg-[#333333] animate-bounce"></span>
                </div>
            );
        }

        if (error) {
            return (
                <span className="block w-full text-center text-sm font-medium text-red-700">
                    {error}
                </span>
            );
        }

        return (
            <>
                <span className="pl-1 text-[18px] font-medium uppercase text-[#40382F] font-spaceMono">
                    Start Here
                </span>
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#6E7E6D] text-[28px] text-white">
                    <ArrowRight />
                </span>
            </>
        );
    };

    return (
        <div
            className="relative h-full overflow-hidden text-white"
            style={{
                backgroundImage: `url(${landingPageLady})`,
                backgroundPosition: "center top",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            }}
        >

            <div className="relative z-10 flex h-full flex-col px-4 pb-6 pt-10">
                <div className="mx-auto flex items-start justify-center w-full max-w-[420px] flex-1">
                    <img
                        src={claraviewBrand}
                        alt="claraview-logo"
                        className="ml-4 h-auto w-[185px] object-contain"
                    />
                </div>

                <div className="relative z-10 mx-auto w-full max-w-[420px] rounded-[18px] border border-white/10 bg-[rgba(68,55,43,0.42)] p-5 shadow-[0_18px_40px_rgba(30,18,9,0.22)] backdrop-blur-[14px]">
                    <p className="mb-3 text-[12px] uppercase tracking-[0.1em] text-white/60 font-spaceMono">
                        AI Smile Simulation
                    </p>
                    <h1 className="max-w-[300px] text-[30px] font-sans leading-[1.08] text-[#F4F2ED]">
                        Capture the now and preview what&apos;s possible.
                    </h1>

                    <button
                        type="button"
                        className={`mt-6 flex h-[56px] w-full items-center rounded-full bg-[#F4F2ED] px-5 text-left transition ${loading || error ? "justify-center" : "justify-between"}`}
                        onClick={error ? undefined : takeScan}
                        disabled={loading || Boolean(error)}
                    >
                        {renderButtonContent()}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
